import React from 'react';

export const EditableContext = React.createContext(null);
